import { useSettingEnableLoggedOutDiscoverStoreTypeSection } from "@faire/deprecated-retailer-visitor-shared/settings/useSettingEnableLoggedOutDiscoverStoreTypeSection";
import { ProductContainerVariant } from "@faire/web-api--source/com/faire/logging/ProductContainerVariant";
import { ProductSurfaceContainer } from "@faire/web-api--source/com/faire/logging/ProductSurfaceContainer";
import { useQuery_escape_hatch as useStoreTypeQuery } from "@faire/web-api--source/endpoints/www/api/v3/layout/logged-out/store-type-carousel/post-hooks";
import { IThreeVariantXP } from "@faire/web-api--source/indigofair/settings/IThreeVariantXP";

export const useFetchStoreType = (query: string) => {
  const storeTypeSectionVariant =
    useSettingEnableLoggedOutDiscoverStoreTypeSection();

  const { data: storeTypeCarousel } = useStoreTypeQuery(
    {
      query,
      product_surface_container:
        ProductSurfaceContainer.LOGGED_OUT_CATEGORY_PRODUCT_RESULTS_PRODUCT_CAROUSEL,
      product_container_variant:
        ProductContainerVariant.PRODUCT_CONTAINER_VARIANT_UNKNOWN,
    },
    {
      enabled:
        !!query && storeTypeSectionVariant !== IThreeVariantXP.Bucket.CONTROL,
    }
  );

  return storeTypeCarousel;
};
